import gql from 'graphql-tag';

export type ProfileLinks = {
  url?: string;
  email?: string;
  github?: string;
  twitter?: string;
  facebook?: string;
};

export type UserProfile = {
  id: string;
  display_name: string;
  short_bio: string;
  thumbnail: string | null;
  about?: string;
  profile_links: ProfileLinks;
};
export type VelogConfig = {
  id: string;
  title: string | null;
  logo_image: string | null;
};
export type User = {
  id: string;
  username: string;
  email: string | null;
  is_certified: boolean;
  profile: UserProfile;
  velogConfig: VelogConfig | null;
  is_followed: boolean;
  is_trusted: boolean;
};

export const GET_CURRENT_USER = gql`
  query CurrentUser {
    auth {
      id
      username
      email
      is_trusted
      profile {
        id
        thumbnail
        display_name
      }
    }
  }
`;

export const GET_VELOG_CONFIG = gql`
  query VelogConfig($username: String) {
    velog_config(username: $username) {
      title
      logo_image
    }
  }
`;

export type CurrentUser = {
  id: string;
  username: string;
  profile: {
    id: string;
    thumbnail: string | null;
    display_name: string;
  };
  email: string;
  is_trusted: boolean;
};

export const GET_USER_PROFILE = gql`
  query UserProfile($username: String!) {
    user(username: $username) {
      id
      username
      profile {
        id
        display_name
        short_bio
        thumbnail
        profile_links
      }
    }
  }
`;

export type GetUserProfileResponse = {
  user: {
    id: string;
    username: string;
    profile: Omit<UserProfile, 'about'>;
  };
};

export const GET_USER_ABOUT = gql`
  query UserAbout($username: String!) {
    user(username: $username) {
      id
      profile {
        id
        about
        display_name
      }
    }
  }
`;

export type GetUserAboutResponse = {
  user: {
    id: string;
    profile: {
      id: string;
      about: string;
      display_name: string;
    };
  };
};

export const GET_USER_SERIES_LIST = gql`
  query UserSeriesList($username: String!) {
    user(username: $username) {
      id
      series_list {
        id
        name
        description
        url_slug
        thumbnail
        updated_at
        posts_count
      }
    }
  }
`;

export const EMAIL_EXISTS = gql`
  query EmailExists($email: String!) {
    emailExists(email: $email)
  }
`;

// Generated by https://quicktype.io

export interface GetUserSeriesListResponse {
  user: {
    id: string;
    series_list: PartialSeries[];
  };
}

export interface PartialSeries {
  id: string;
  name: string;
  description: null;
  url_slug: string;
  thumbnail: null | string;
  updated_at: string;
  posts_count: number;
}

export const UPDATE_ABOUT = gql`
  mutation UpdateAbout($about: String!) {
    update_about(about: $about) {
      id
      about
    }
  }
`;

export const LOGOUT = gql`
  mutation Logout {
    logout
  }
`;

export const ACCEPT_INTEGRATION = gql`
  mutation AcceptIntegration {
    acceptIntegration
  }
`;

export const CONFIRM_CHANGE_EMAIL = gql`
  mutation ConfirmChangeEmail($code: String!) {
    confirmChangeEmail(code: $code)
  }
`;

export const FOLLOW_USER = gql`
  mutation Follow($following_user_id: ID!) {
    follow(following_user_id: $following_user_id) {
      id
      is_followed
    }
  }
`;

export const UNFOLLOW_USER = gql`
  mutation Unfollow($following_user_id: ID!) {
    unfollow(following_user_id: $following_user_id) {
      id
      is_followed
    }
  }
`;

export type AcceptIntegrationResponse = {
  acceptIntegration: string;
};
